// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__xd9_i","wrapperOpened":"styles_wrapperOpened__F5VS5","wrapperForUser":"styles_wrapperForUser__C6w4d"};
module.exports.__checksum = "44735caa6f07"
